import { useState } from "react";
import CommonInput from "../../components/CommonInput";
import { Input } from "../../components/inputs";
import CommonResult from "../../components/CommonResult/index";
import { instance } from "../../services/https/inceptors";
import { endpoints } from "../../constants/Endpoints";
import { showToast } from "../../utilities/toast";
import { useRecoilValue } from "recoil";
import {
  department as recoilDepart,
  exam as recoilExam,
  selectedDepartmentObject,
} from "../../providers/index";
import { useHistory } from "react-router-dom";
import { Button } from "../../components/buttons";
import { AWS_DIRECTORIES, LANGUAGES } from "../../constants/Common";
import ReactSelect from 'react-select';

const CreateVideo = () => {
  const [language, setSelectedLanguage] = useState({
    value: 'en',
    label: 'English',
  });

  const [name, setName] = useState({ [language.value]: '' });
  const [description, setDescription] = useState({ [language.value]: '' });
  const [link, setLink] = useState({ [language.value]: '' });
  const selectedDepart = useRecoilValue(selectedDepartmentObject);


  const department = useRecoilValue(recoilDepart).split("/")[1];
  const exam = useRecoilValue(recoilExam).split("/")[1];
  const { goBack } = useHistory();

  const onSubmit = async () => {
    try {
      await instance.post(endpoints.addVideo, {
        ...{ name, description, exam, department, link },
      });

      showToast({
        type: "success",
        message: "Successfully Saved General Video!",
      });

      goBack(false);
    } catch (err) {
      showToast({ type: "error", message: err.response.data.message });
    }
  };

  const onLanguageChange = (e) => {
    setSelectedLanguage(e);

    setName((prev) => {
      if (!prev[e.value]) return { ...prev, [e.value]: '' };
      else return prev;
    });

    setLink((prev) => {
      if (!prev[e.value]) return { ...prev, [e.value]: '' };
      else return prev;
    });

    setDescription((prev) => {
      if (!prev[e.value]) return { ...prev, [e.value]: '' };
      else return prev;
    });
  };

  return (
    <div className='container'>
      <h2 className='space-heading text-center mb-2'>Create Video</h2>
      <div className='mb-4 px-3'>
        <h6 className='mb-1'>Select Language</h6>
        <ReactSelect
          onChange={onLanguageChange}
          options={selectedDepart?.languages?.map((lang) => {
            const label = Object.keys(LANGUAGES).find(
              (key) => LANGUAGES[key] === lang
            );
            return {
              value: lang,
              label: label.replace(/^./, label[0].toUpperCase()),
            };
          })}
          value={language}
          placeholder='Select Language'
          className='w-52'
        />
      </div>
      <div className="container create-screen">
        <div className="edit-section question-scroll">
          <Input
            className='!w-56'
            id='name'
            label='Name'
            value={name?.[language?.value]}
            onChange={e => setName(prev => ({ ...prev, [language.value]: e }))}
          />

          <CommonInput
            directory={AWS_DIRECTORIES.EXAM_ANALYSIS}
            language={language.value}
            label="Description"
            value={description[language.value]}
            onChange={setDescription}
          />

          <Input
            id='link'
            label='Link'
            value={link?.[language?.value]}
            onChange={e => setLink(prev => ({ ...prev, [language.value]: e }))}
          />

        </div>
        <div className="result-section question-scroll">
          <div className="pb-5">
            <h6>Name:</h6>
            <p>{name?.[language.value]}</p>
          </div>

          <CommonResult language={language.value} label="Description:" text={description} />

          <div className="pt-5">
            <h6>Image Link:</h6>
            <p>{link?.[language.value]}</p>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center w-100 mt-5 mb-5">
        <Button className="w-25" onClick={onSubmit} disabled={!link?.[language.value] || !name?.[language.value]}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CreateVideo;
